import React, { useState, useEffect, useRef, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { walletAmount, WalletValue, useAuth } from '../context/AuthContext';
import { Package, ArrowLeft, Unlock, AlertCircle, Loader2, ShieldCheck, Layers, ChevronLeft, ChevronRight, Search, ArrowDown, ArrowUp, Activity, X, Plus } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';
import { useChatLayout } from '../context/ChatLayoutContext';
import { DynamicCasePreview } from '../components/CasePreview';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

// ==========================================
// AMOUNT FORMATTER
// ==========================================
const formatAmount = (num) => {
  if (num === undefined || num === null) return "0";
  if (num >= 1000000) return num.toLocaleString();
  if (num >= 1000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  return num.toString();
};

// 🎨 DynamicCasePreview TEK KAYNAKTAN gelir (components/CasePreview).
// Bu dosyada AYRI bir kopyası vardı: ALTI dosyada altı kopya zamanla
// ayrışıyor ve her düzeltme altı yere dokunmayı gerektiriyordu.
export const CaseOpening = () => {
  const { token, isAuthenticated, fmtMoney, balance, wallet } = useAuth();
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCase, setSelectedCase] = useState(null);
  const [spinning, setSpinning] = useState(false);
  
  // YENİ: Çoklu kasa açılımı için stateler (Dizi halindeler)
  const [openCount, setOpenCount] = useState(1);
  const [spinnerItemsArray, setSpinnerItemsArray] = useState([]);
  const [spinOffsets, setSpinOffsets] = useState([]);
  const [wonItems, setWonItems] = useState([]);
  
  // 🌟 Kasa kaynağı: 'donutluck' (resmi) | 'community' — varsayılan BloxBets
  const [caseSource, setCaseSource] = useState('donutluck');
  // 🌟 Sıralama: 'popularity' | 'price' + yön 'high' (çoktan aza) | 'low' (azdan çoğa)
  const [sortBy, setSortBy] = useState('popularity');
  const [sortDir, setSortDir] = useState('high');

  // 🔍 Arama (debounced — her tuşta sunucuya gitmesin)
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  // 🌟 Community: SUNUCU-TARAFLI sayfalama (hepsini bir anda yüklemeyiz — lag yok)
  const COMMUNITY_PAGE = 30;
  const [communityCases, setCommunityCases] = useState([]);
  const [communityLoading, setCommunityLoading] = useState(false);
  const [communityHasMore, setCommunityHasMore] = useState(false);
  const [communityLoadingMore, setCommunityLoadingMore] = useState(false);

  const [clientSeed, setClientSeed] = useState(() => Math.random().toString(36).substring(2, 10));
  const [provablyFairData, setProvablyFairData] = useState(null);
  // 💬 Aç/kapa durumu paylaşımlı: sayfa değişse de korunur.
  const { chatOpen } = useChatLayout();

  const containerRef = useRef(null); 
  const spinnerRef = useRef(null);
  const STOP_INDEX = 75;
  /* ⚠️ ŞERİT UZUNLUĞU CİHAZA GÖRE. Şerit her zaman 100 öğe üretiliyordu ama
     çark STOP_INDEX'te (75) duruyor: son 19 öğe HİÇ görünmüyor. Ve 5 kasa
     açıldığında bu 500 öğe × ~5 DOM düğümü + 500 görsel demek — telefonda
     bellek baskısı yaratıp sekmeyi düşürebiliyor.
     Masaüstünde birkaç öğe pay bırakıyoruz; mobilde şeridi kısaltıyoruz
     (çark yine STOP_INDEX'te durduğu için animasyon AYNI görünür). */
  const STRIP_LENGTH = (typeof window !== 'undefined' && window.innerWidth < 640)
    ? STOP_INDEX + 4
    : STOP_INDEX + 8; 
  const ITEM_WIDTH = 160; 

  const audioPool = useRef([]);
  const poolIdx = useRef(0);

  useEffect(() => {
    if (typeof Audio !== "undefined") {
      const pool = [];
      for (let i = 0; i < 7; i++) {
        const a = new Audio('/reel_tick.mp3');
        a.volume = 0.4;
        pool.push(a);
      }
      audioPool.current = pool;
    }
  }, []);

  const playTickSound = () => {
    if (audioPool.current.length > 0) {
      const audio = audioPool.current[poolIdx.current];
      audio.currentTime = 0; 
      const playPromise = audio.play();
      if (playPromise !== undefined) playPromise.catch(e => {});
      poolIdx.current = (poolIdx.current + 1) % audioPool.current.length;
    }
  };

  useEffect(() => {
    // Ses takibini sadece 1. çarka (spinnerRef) yapıyoruz ki kulak tırmalamasın
    if (!spinning || !containerRef.current || !spinnerRef.current) return;

    let animationFrame;
    let lastPassedItem = -1;

    const checkPosition = () => {
      /* ⚠️ REF'LER HER KAREDE YENİDEN KONTROL EDİLİR.
         Efekt kurulurken bir kez bakmak yetmiyor: bu geri çağırma sonraki
         karelerde de çalışıyor ve o sırada bileşen sökülmüş ya da ref
         kopmuş olabilir. window.getComputedStyle(null) HATA FIRLATIR ve
         requestAnimationFrame içindeki hata React'in hata sınırını
         tetikleyip ekranı komple boşaltır — "kasa açınca çöküyor"
         raporunun en olası kaynağı bu. */
      const sp = spinnerRef.current;
      const ct = containerRef.current;
      if (!sp || !ct) return;                 // sessizce dur, döngüyü kurma

      let currentX = 0;
      try {
        const transform = window.getComputedStyle(sp).transform;
        if (transform && transform !== 'none') {
          /* ⚠️ matrix() 6, matrix3d() 16 değer taşır ve X ötelemesi
             FARKLI indekstedir (4 / 12). Mobil tarayıcılar GPU hızlandırma
             için sıklıkla matrix3d üretir; sabit [4] okumak orada YANLIŞ
             sayı verip tik sesini bozuyordu. */
          /* ⚠️ Sayılar PARANTEZ İÇİNDEN alınır. Doğrudan tüm dizede arama
             yapmak "matrix3d" içindeki 3'ü de yakalar ve TÜM indeksleri
             bir kaydırır — mobilde yanlış konum okunurdu. */
          const inner = transform.slice(transform.indexOf('(') + 1);
          const nums = inner.match(/-?\d*\.?\d+(?:e[-+]?\d+)?/gi) || [];
          const idx = transform.startsWith('matrix3d') ? 12 : 4;
          const v = parseFloat(nums[idx]);
          if (Number.isFinite(v)) currentX = v;
        }
      } catch (e) { /* ölçüm başarısızsa ses atlanır, akış bozulmaz */ }

      const containerWidth = ct.offsetWidth || 0;
      if (containerWidth > 0) {
        const centerPoint = containerWidth / 2;
        const currentItem = Math.floor((-currentX + centerPoint) / ITEM_WIDTH);
        if (Number.isFinite(currentItem)) {
          if (lastPassedItem === -1) {
            lastPassedItem = currentItem;
          } else if (currentItem > lastPassedItem) {
            playTickSound();
            lastPassedItem = currentItem;
          }
        }
      }

      animationFrame = requestAnimationFrame(checkPosition);
    };

    animationFrame = requestAnimationFrame(checkPosition);
    return () => cancelAnimationFrame(animationFrame);
  }, [spinning]);


  useEffect(() => {
    fetchCases();
  }, []);

  // 🔍 Arama debounce (300ms) — her tuşta sunucuya gitmesin
  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search.trim()), 300);
    return () => clearTimeout(t);
  }, [search]);

  // Frontend sort + dir → backend sort param
  const serverSort = `${sortBy === 'popularity' ? 'popularity' : 'price'}_${sortDir === 'high' ? 'desc' : 'asc'}`;

  // 🌟 Community: arama/sıralama değişince ilk sayfayı (skip=0) çek
  useEffect(() => {
    if (caseSource !== 'community') return;
    let cancelled = false;
    const fetchFirst = async () => {
      setCommunityLoading(true);
      try {
        const params = new URLSearchParams({ limit: COMMUNITY_PAGE, skip: 0, sort: serverSort });
        if (debouncedSearch) params.set('search', debouncedSearch);
        const res = await axios.get(`${BACKEND_URL}/api/game/cases/community?${params.toString()}`);
        if (cancelled) return;
        const data = res.data || [];
        setCommunityCases(data);
        setCommunityHasMore(data.length === COMMUNITY_PAGE);
      } catch (error) {
        if (!cancelled) toast.error("Could not load community cases.");
      } finally {
        if (!cancelled) setCommunityLoading(false);
      }
    };
    fetchFirst();
    return () => { cancelled = true; };
  }, [caseSource, debouncedSearch, serverSort]);

  // "Load More" → bir sonraki sayfayı çekip ekle
  const loadMoreCommunity = async () => {
    if (communityLoadingMore || !communityHasMore) return;
    setCommunityLoadingMore(true);
    try {
      const params = new URLSearchParams({ limit: COMMUNITY_PAGE, skip: communityCases.length, sort: serverSort });
      if (debouncedSearch) params.set('search', debouncedSearch);
      const res = await axios.get(`${BACKEND_URL}/api/game/cases/community?${params.toString()}`);
      const data = res.data || [];
      setCommunityCases(prev => [...prev, ...data]);
      setCommunityHasMore(data.length === COMMUNITY_PAGE);
    } catch (error) {
      toast.error("Could not load more cases.");
    } finally {
      setCommunityLoadingMore(false);
    }
  };

  // Kasa veya Kasa Sayısı seçildiğinde Çarkları (Strip) yeniden oluştur
  useEffect(() => {
    if (selectedCase && !spinning) {
      initSpinners(openCount);
    }
  }, [selectedCase, openCount]);

  const initSpinners = (count) => {
    let newSpinnerItems = [];
    for (let i = 0; i < count; i++) {
        let strip = [];
        for (let j = 0; j < 100; j++) strip.push(getRandomItemFromCase(selectedCase));
        newSpinnerItems.push(strip);
    }
    setSpinnerItemsArray(newSpinnerItems);
    setSpinOffsets(Array(count).fill(0));
    setWonItems([]);
  };

  const fetchCases = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/game/cases`);
      const list = response.data || [];
      setCases(list);
      // 🔄 AÇIK KASAYI DA TAZELE. Seçili kasa listenin bir KOPYASIDIR;
      // yalnızca `cases`i güncellemek açık kasayı eski fiyatlarda bırakır.
      setSelectedCase(prev => {
        if (!prev) return prev;
        const fresh = list.find(c => c.id === prev.id);
        if (!fresh) {
          // LC'de EV testini geçemeyip listeden düşmüş: seçimi kapat.
          toast.error("This case isn't available with your current wallet.");
          return null;
        }
        return fresh;
      });
      return list;
    } catch (error) {
      toast.error("Failed to load cases!");
      return null;
    } finally {
      setLoading(false);
    }
  };

  // 🍀 Cüzdan değişince kasa listesi YENİDEN çekilir: fiyatlar aktif
  // cüzdanın biriminde geliyor ve EV doğrulamasını geçemeyen kasalar
  // LC'de listeden düşürülüyor. Tazelenmezse kullanıcı eski birimdeki
  // fiyatı görür ve gördüğünden farklı ödeme yapar.
  useEffect(() => {
    const onWalletChange = () => {
      // ⚠️ Dönen animasyon ORTASINDA cüzdan değişirse şerit eski
      // fiyatlarla kalır ve sonuç ekranı yanlış tutar gösterir; bu
      // yüzden önce çevir, sonra tazele.
      setSpinning(false);
      setWonItems([]);
      fetchCases();
    };
    window.addEventListener('wallet:changed', onWalletChange);
    return () => window.removeEventListener('wallet:changed', onWalletChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getRandomItemFromCase = (caseData) => {
    const totalWeight = caseData.items.reduce((sum, item) => sum + item.weight, 0);
    let randomNum = Math.random() * totalWeight;
    for (const item of caseData.items) {
      randomNum -= item.weight;
      if (randomNum <= 0) return item;
    }
    return caseData.items[0];
  };

  const handleOpenCase = async () => {
    if (!isAuthenticated) return toast.error("Please log in first!");
    if (spinning) return;

    setWonItems([]);
    setSpinOffsets(Array(openCount).fill(0)); 

    try {
      const response = await axios.post(`${BACKEND_URL}/api/game/cases/open`, 
        { case_id: selectedCase.id, amount: openCount, client_seed: clientSeed },
        { headers: { Authorization: `Bearer ${token}` }}
      );
      
      setProvablyFairData({
        serverSeed: response.data.server_seed,
        clientSeed: response.data.client_seed
      });
      setClientSeed(Math.random().toString(36).substring(2, 10));

      const winningItemsData = response.data.unboxed;
      
      let newSpinnerItems = [];
      let newOffsets = [];
      let realWinningItems = [];
      
      const containerWidth = containerRef.current?.offsetWidth || 800; 
      const centerOffset = (containerWidth / 2) - (ITEM_WIDTH / 2);

      // Her bir kasa açılımı için kazanılan eşyayı yerleştir ve duracağı yeri (offset) hesapla
      for (let i = 0; i < openCount; i++) {
          let strip = [];
          for (let j = 0; j < STRIP_LENGTH; j++) strip.push(getRandomItemFromCase(selectedCase));
          
          /* ⚠️ Yedek indeks STRIP_LENGTH'e bağlı olmalı: sabit 75, kısaltılmış
             şeritte undefined döndürüp render'da çökerdi. */
          const realWinningItem =
            selectedCase.items.find(item => item.name === winningItemsData[i].name)
            || strip[Math.min(STOP_INDEX, strip.length - 1)];
          strip[STOP_INDEX] = realWinningItem;
          
          newSpinnerItems.push(strip);
          realWinningItems.push(realWinningItem);
          
          // Her çark birbirinden hafif farklı yerlerde dursun (daha organik bir görünüm)
          const randomStop = Math.floor(Math.random() * 80) - 40; 
          const finalOffset = -(STOP_INDEX * ITEM_WIDTH) + centerOffset + randomStop;
          newOffsets.push(finalOffset);
      }

      setSpinnerItemsArray(newSpinnerItems);

      // Çarkı Çevirme Animasyon Süreci
      setTimeout(() => {
        setSpinning(true); 
        setTimeout(() => {
          setSpinOffsets(newOffsets); // Hedefe doğru kayma başlar
          setTimeout(() => {
            setSpinning(false);
            setWonItems(realWinningItems);
          }, 5000);
        }, 50); 
      }, 50);

    } catch (error) {
      setSpinning(false);
      toast.error(error.response?.data?.detail || "Failed to open case.");
    }
  };

  // 🌟 Popülerlik = toplam açılma × (fiyat / 10) — BloxBets client-side sıralaması için
  const popularityOf = (c) => (c.total_opens || 0) * ((c.price || 0) / 10);

  // 🌟 Gösterilecek liste:
  //   BloxBets → client-side filtre (arama) + sıralama (az sayıda, lag yok)
  //   Community → sunucudan zaten filtrelenmiş + sıralanmış + sayfalanmış geldi
  const displayedCases = useMemo(() => {
    if (caseSource === 'community') return communityCases;
    let arr = [...cases];
    const q = debouncedSearch.toLowerCase();
    if (q) arr = arr.filter(c => (c.name || '').toLowerCase().includes(q));
    arr.sort((a, b) => {
      const va = sortBy === 'popularity' ? popularityOf(a) : (a.price || 0);
      const vb = sortBy === 'popularity' ? popularityOf(b) : (b.price || 0);
      let cmp = vb - va;                 // 'high' = çoktan aza (varsayılan)
      if (cmp === 0) cmp = (b.price || 0) - (a.price || 0); // eşitlikte fiyata göre stabil
      return sortDir === 'low' ? -cmp : cmp;
    });
    return arr;
  }, [caseSource, cases, communityCases, debouncedSearch, sortBy, sortDir]);

  const poolLoading = caseSource === 'community' ? communityLoading : loading;

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0E0F11] flex items-center justify-center">
        <Loader2 className="w-12 h-12 text-[#B059E8] animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0E0F11]" data-testid="cases-page">
      <div className="max-w-[1800px] mx-auto px-4 pt-24 pb-8">
        <div className={`flex flex-col lg:flex-row gap-6 transition-[padding] duration-300 ${chatOpen ? 'md:pl-[340px] lg:pl-[370px]' : ''}`}>
          
          {/* LEFT SIDE: LIVE CHAT */}
          {/* 💬 Sohbet App.js'te TEK kopya render ediliyor (ChatDock).
              Sayfa-içi kopya kaldırıldı: her gezinmede WebSocket kopup
              yeniden bağlanıyor ve 4 HTTP isteği tekrar atılıyordu. */}
          {/* RIGHT SIDE: GAME AREA */}
          <main className="flex-1 flex flex-col min-w-0 lg:h-[calc(100vh-120px)] relative">
            <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#16A34A]/5 rounded-full blur-[150px] pointer-events-none z-0" />
            <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#B059E8]/5 rounded-full blur-[150px] pointer-events-none z-0" />

            <div className="flex-1 overflow-y-auto relative scrollbar-thin rounded-2xl z-10">
              <div className={`mx-auto transition-all duration-500 ${!selectedCase ? 'max-w-7xl' : 'max-w-4xl'}`}>
                
                <AnimatePresence mode="wait">
                  {!selectedCase ? (
                    <motion.div key="list" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, scale: 0.95 }} transition={{ duration: 0.3 }} className="pb-12">
                      
                      <div className="text-center mb-10 mt-4">
                        <h1 className="text-4xl md:text-5xl font-black text-white uppercase tracking-wider mb-4 flex items-center justify-center gap-3">
                          <Package className="w-10 h-10 text-[#16A34A]" />
                          Case <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2ecf6e] to-[#16A34A]">Opening</span>
                        </h1>
                      </div>

                      {/* 🌟 FİLTRE BARI: Kaynak sekmeleri + Arama + Sıralama */}
                      <div className="bg-[#1A1D20] border border-[#2A2D31] rounded-2xl p-4 mb-6 space-y-3 shadow-lg">
                        {/* 🌟 KAYNAK SEKMELERİ: BloxBets / Community */}
                        <div className="flex items-center gap-1.5 p-1 bg-[#15171a] rounded-xl border border-[#2A2D31]">
                          {[
                            { k: 'donutluck', label: 'BloxBets Cases' },
                            { k: 'community', label: 'Community Cases' },
                          ].map(s => (
                            <button
                              key={s.k}
                              onClick={() => setCaseSource(s.k)}
                              className={`flex-1 px-3 py-2.5 rounded-lg text-xs font-black uppercase tracking-widest transition-all ${
                                caseSource === s.k
                                  ? 'bg-[#16A34A]/15 text-white border border-[#16A34A]/50 shadow-[0_0_15px_rgba(22,163,74,0.15)]'
                                  : 'text-zinc-500 hover:text-zinc-300 border border-transparent'
                              }`}
                            >
                              {s.label}
                            </button>
                          ))}
                        </div>

                        {/* 🔍 İSİMLE ARAMA */}
                        <div className="relative">
                          <Search className="w-4 h-4 text-zinc-500 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
                          <input
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            placeholder="Search cases by name..."
                            className="w-full bg-[#15171a] border border-[#2A2D31] rounded-xl pl-9 pr-9 py-2.5 text-sm text-white outline-none focus:border-[#16A34A] transition-colors"
                          />
                          {search && (
                            <button
                              onClick={() => setSearch('')}
                              className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-white transition-colors"
                              aria-label="Clear search"
                            >
                              <X className="w-4 h-4" />
                            </button>
                          )}
                        </div>

                        {/* 🌟 SIRALAMA: Popularity / Price + High/Low yön toggle */}
                        <div className="flex items-center justify-between gap-2">
                          <div className="flex items-center gap-1.5 p-1 bg-[#15171a] rounded-xl border border-[#2A2D31]">
                            {[
                              { k: 'popularity', label: 'Popularity' },
                              { k: 'price', label: 'Price' },
                            ].map(s => (
                              <button
                                key={s.k}
                                onClick={() => setSortBy(s.k)}
                                className={`px-3 py-1.5 rounded-lg text-[10px] font-bold uppercase tracking-widest transition-all ${
                                  sortBy === s.k
                                    ? 'bg-[#16A34A]/15 text-white border border-[#16A34A]/50'
                                    : 'text-zinc-500 hover:text-zinc-300 border border-transparent'
                                }`}
                              >
                                {s.label}
                              </button>
                            ))}
                          </div>
                          <button
                            onClick={() => setSortDir(d => (d === 'high' ? 'low' : 'high'))}
                            title={sortDir === 'high' ? 'High to low' : 'Low to high'}
                            className="flex items-center gap-1.5 px-3 py-2 rounded-xl bg-[#15171a] border border-[#2A2D31] text-zinc-300 hover:text-white hover:border-[#16A34A]/50 text-[10px] font-black uppercase tracking-widest transition-all shrink-0"
                          >
                            {sortDir === 'high'
                              ? <><ArrowDown className="w-3.5 h-3.5" /> High</>
                              : <><ArrowUp className="w-3.5 h-3.5" /> Low</>}
                          </button>
                        </div>
                      </div>

                      {/* 🌟 KASA GRİDİ — Yükleme / Boş / Sonuç durumları */}
                      {poolLoading ? (
                        <div className="py-20 flex justify-center">
                          <Activity className="w-8 h-8 text-[#16A34A] animate-spin" />
                        </div>
                      ) : displayedCases.length === 0 ? (
                        <div className="bg-[#1A1D20] border border-[#2A2D31] rounded-2xl p-12 text-center">
                          <AlertCircle className="w-12 h-12 text-zinc-500 mx-auto mb-4" />
                          <h3 className="text-xl font-bold text-white mb-2">
                            {debouncedSearch
                              ? `No cases match "${debouncedSearch}"`
                              : caseSource === 'community' ? 'No Community Cases Yet' : 'No Cases Available'}
                          </h3>
                          {debouncedSearch && (
                            <p className="text-sm text-zinc-500 mt-1">Try a different search term.</p>
                          )}
                        </div>
                      ) : (
                        <>
                          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
                            <AnimatePresence>
                              {displayedCases.map((c) => (
                                <motion.div 
                                  initial={{ opacity: 0, scale: 0.9 }}
                                  animate={{ opacity: 1, scale: 1 }}
                                  exit={{ opacity: 0, scale: 0.9 }}
                                  transition={{ duration: 0.2 }}
                                  key={c.id} 
                                  onClick={() => setSelectedCase(c)}
                                  className="bg-[#1A1D20] border border-[#2A2D31] rounded-2xl p-5 cursor-pointer group hover:border-[#16A34A]/50 hover:shadow-[0_0_30px_rgba(22,163,74,0.15)] transition-all relative flex flex-col items-center overflow-hidden"
                                >
                                  {/* 🌟 Community rozeti */}
                                  {c.is_community && (
                                    <div className="absolute top-2 left-2 z-30 bg-[#B059E8]/15 border border-[#B059E8]/40 text-[#d1a3f2] px-2 py-0.5 rounded-md text-[9px] font-black uppercase tracking-widest">
                                      Community
                                    </div>
                                  )}

                                  <div className="h-32 flex items-center justify-center mb-4 relative w-full pointer-events-none">
                                    <div className="absolute inset-0 bg-[#16A34A]/5 rounded-full blur-2xl group-hover:bg-[#16A34A]/10 transition-colors" />
                                    
                                    {c.image_url?.startsWith('color:') ? (
                                      <div className="w-24 h-24 group-hover:scale-110 transition-transform duration-300 relative z-10">
                                        <DynamicCasePreview caseColor={c.image_url} items={c.items} showcase={c.showcase} />
                                      </div>
                                    ) : (
                                      <img src={c.image_url} alt={c.name} className="max-h-full object-contain group-hover:scale-110 transition-transform duration-300 relative z-10 drop-shadow-2xl" />
                                    )}
                                  </div>

                                  <div className="bg-[#16A34A]/10 border border-[#16A34A]/30 text-[#2ecf6e] px-3 py-1 rounded-lg mm-num font-black text-base mb-3 shadow-[0_0_15px_rgba(22,163,74,0.15)] z-20 group-hover:bg-[#16A34A]/20 transition-colors">
                                    <WalletValue amount={c.price} wallet={wallet} />
                                  </div>

                                  <h3 className="text-lg font-black text-white text-center uppercase tracking-wide w-full truncate px-2" title={c.name}>{c.name}</h3>
                                  <p className="text-center text-xs text-zinc-500 mt-1">{c.items.length} Items Inside</p>
                                </motion.div>
                              ))}
                            </AnimatePresence>
                          </div>

                          {/* 🌟 Community: Load More (sunucu-taraflı sayfalama — lag yok) */}
                          {caseSource === 'community' && communityHasMore && (
                            <div className="mt-6 flex justify-center">
                              <button
                                onClick={loadMoreCommunity}
                                disabled={communityLoadingMore}
                                className="px-8 py-3 rounded-xl bg-[#1A1D20] border border-[#2A2D31] hover:border-[#16A34A]/50 text-zinc-300 hover:text-white text-xs font-black uppercase tracking-widest transition-all flex items-center justify-center gap-2 disabled:opacity-50"
                              >
                                {communityLoadingMore ? <Activity className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />}
                                Load More
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </motion.div>
                  ) : (
                    <motion.div key="detail" initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, y: 20 }} transition={{ duration: 0.3 }} className="flex flex-col pb-12 w-full">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
                        <button onClick={() => !spinning && setSelectedCase(null)} className={`flex items-center gap-2 text-zinc-400 hover:text-white transition-colors w-fit ${spinning ? 'opacity-50 cursor-not-allowed' : ''}`}>
                          <ArrowLeft className="w-5 h-5" />
                          <span>Back to Cases</span>
                        </button>
                      </div>

                      <div className="bg-[#1A1D20] border border-[#2A2D31] rounded-3xl overflow-hidden shadow-2xl flex-1 flex flex-col relative">
                        
                        {/* ÇOKLU KASA ÇARKLARI ALANI */}
                        <div className="flex flex-col gap-2 p-4 bg-[#121417] border-b border-[#2A2D31] relative shrink-0">
                            {spinnerItemsArray.map((strip, idx) => (
                                <div key={idx} ref={idx === 0 ? containerRef : null} className="h-36 relative flex flex-col justify-center overflow-hidden rounded-xl bg-black/20 border border-white/5 shadow-inner">
                                    <div className="absolute left-1/2 top-0 bottom-0 w-1 bg-[#B059E8] shadow-[0_0_15px_rgba(176,89,232,0.8)] z-20 -translate-x-1/2" />
                                    
                                    <div 
                                        ref={idx === 0 ? spinnerRef : null} 
                                        className="flex items-center absolute left-0" 
                                        style={{ transform: `translateX(${spinOffsets[idx] || 0}px)`, transition: spinning ? 'transform 5s cubic-bezier(0.1, 0.7, 0.1, 1)' : 'none', gap: '16px' }}
                                    >
                                        {strip.length > 0 ? strip.map((item, itemIdx) => (
                                          <div key={itemIdx} className="w-[144px] h-[120px] flex-shrink-0 rounded-xl border border-white/5 bg-black/40 flex flex-col items-center justify-center p-2 relative overflow-hidden" style={{ borderBottom: `4px solid ${item.color || '#4ade80'}` }}>
                                            <div className="absolute inset-0 opacity-20" style={{ background: `radial-gradient(circle at center, ${item.color || '#4ade80'} 0%, transparent 70%)` }} />
                                            {/* decoding=async: kod çözme ana iş parçacığını bloklamaz;
                                                telefonda çark takılmasını azaltır. */}
                                            <img src={item.image_url} alt={item.name} decoding="async" className="w-12 h-12 object-contain mb-2 relative z-10 drop-shadow-lg" />
                                            <span className="text-white text-[10px] font-bold text-center truncate w-full relative z-10">{item.name}</span>
                                            <span className="text-[#2ecf6e] mm-num text-[10px] mt-0.5 relative z-10"><WalletValue amount={item.price} wallet={wallet} /></span>
                                          </div>
                                        )) : <div className="w-full flex justify-center text-zinc-600 font-bold uppercase tracking-widest absolute left-1/2 -translate-x-1/2">Loading Items...</div>}
                                    </div>
                                    
                                    <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#121417] to-transparent z-10 pointer-events-none" />
                                    <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#121417] to-transparent z-10 pointer-events-none" />
                                </div>
                            ))}
                        </div>

                        {/* AÇMA BUTONU VE MİKTAR SEÇİCİ */}
                        <div className="p-6 flex flex-col items-center justify-center relative bg-[#1A1D20] shrink-0">
                          <h2 className="text-2xl sm:text-3xl font-black text-white uppercase tracking-wider mb-6 flex items-center gap-2">
                             {selectedCase.name}
                          </h2>

                          {/* KAZANILAN EŞYALAR */}
                          {wonItems.length > 0 && !spinning && (
                            <div className="flex flex-wrap justify-center gap-4 mb-8 z-10">
                                {wonItems.map((wonItem, idx) => (
                                    <motion.div key={idx} initial={{ opacity: 0, y: 20, scale: 0.8 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ delay: idx * 0.1 }} className="p-3 pr-6 bg-[#16A34A]/10 border border-[#16A34A]/30 rounded-2xl flex items-center gap-4">
                                        <img src={wonItem.image_url} alt="Won" className="w-12 h-12 object-contain drop-shadow-lg" />
                                        <div>
                                            <p className="text-[#2ecf6e] font-bold text-[10px] uppercase tracking-wider">You Won</p>
                                            <p className="text-sm font-black text-white truncate max-w-[150px]">{wonItem.name}</p>
                                            <p className="text-[#2ecf6e] mm-num font-bold text-xs">+<WalletValue amount={wonItem.price} wallet={wallet} /></p>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                          )}
                          
                          {/* KAÇ TANE AÇILACAK SEÇİCİ */}
                          <div className="flex flex-col items-center gap-4">
                              <div className="bg-[#15171a] border border-[#2A2D31] rounded-xl p-1.5 flex gap-1 shadow-inner">
                                  {[1, 2, 3, 4].map(num => (
                                      <button
                                          key={num}
                                          onClick={() => !spinning && setOpenCount(num)}
                                          disabled={spinning}
                                          className={`px-5 py-2 rounded-lg font-black text-sm transition-all ${openCount === num ? 'bg-[#16A34A] text-white shadow-[0_0_15px_rgba(22,163,74,0.5)]' : 'text-zinc-500 hover:text-white hover:bg-[#33363b]/50'}`}
                                      >
                                          {num}
                                      </button>
                                  ))}
                              </div>

                              <button onClick={handleOpenCase} disabled={spinning} className={`group relative px-10 py-4 bg-[#16A34A] hover:bg-[#15913f] rounded-xl font-black text-white text-lg sm:text-xl uppercase tracking-widest transition-all duration-300 shadow-[0_0_20px_rgba(22,163,74,0.3)] hover:shadow-[0_0_30px_rgba(22,163,74,0.5)] hover:scale-105 overflow-hidden ${spinning ? 'opacity-50 cursor-not-allowed scale-100 hover:scale-100 hover:shadow-[0_0_20px_rgba(22,163,74,0.3)]' : ''}`}>
                                <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-in-out" />
                                <div className="relative z-10 flex items-center justify-center gap-3 w-full">
                                  {spinning ? <Loader2 className="w-6 h-6 animate-spin" /> : <Unlock className="w-6 h-6" />}
                                  <span>{spinning ? 'Opening...' : `Open ${openCount} For ${walletAmount(selectedCase.price * openCount, wallet)}`}</span>
                                </div>
                              </button>
                          </div>
                        </div>

                        {/* KASA İÇERİĞİ (CASE CONTENTS) */}
                        <div className="bg-[#15171a] p-6 pb-20 border-t border-[#2A2D31] flex-1">
                          <h3 className="text-sm font-bold text-white mb-4 flex items-center gap-2 uppercase tracking-widest">
                            <span className="w-1.5 h-4 bg-[#16A34A] rounded-full" />
                            Case Contents
                          </h3>
                          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-4">
                            {[...selectedCase.items].sort((a, b) => b.price - a.price).map((item, idx) => (
                              <div key={idx} className="bg-[#1A1D20] rounded-xl p-4 border border-white/5 relative flex flex-col items-center group hover:bg-[#15171a] transition-colors" style={{ borderBottom: `3px solid ${item.color || '#4ade80'}` }}>
                                <div className="absolute top-2 right-2 text-[10px] font-bold text-zinc-500 group-hover:text-zinc-300 transition-colors">{item.chance}%</div>
                                <img src={item.image_url} alt={item.name} className="w-12 h-12 object-contain mb-3 drop-shadow-md group-hover:scale-110 transition-transform" />
                                <span className="text-zinc-300 text-xs font-bold text-center mb-1 w-full truncate" title={item.name}>{item.name}</span>
                                <span className="text-[#2ecf6e] mm-num text-xs"><WalletValue amount={item.price} wallet={wallet} /></span>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="absolute bottom-4 left-4 right-4 flex flex-col md:flex-row items-center justify-between gap-2 text-[10px] md:text-xs text-zinc-500 mm-num pointer-events-none px-2 z-20">
                          <div className="flex items-center gap-1.5">
                            <ShieldCheck className="w-4 h-4 text-[#16A34A]" />
                            <span>Provably Fair</span>
                          </div>
                          {provablyFairData && !spinning && (
                            <div className="flex flex-col md:flex-row gap-2 md:gap-4 w-full md:w-auto overflow-hidden opacity-70 items-end md:items-center">
                                <span className="truncate text-[#16A34A]" title={provablyFairData.serverSeed}>
                                  <span className="text-[#15913f]">Server Seed:</span> {provablyFairData.serverSeed.substring(0, 16)}...
                                </span>
                                <span className="truncate text-[#16A34A]" title={provablyFairData.clientSeed}>
                                  <span className="text-[#15913f]">Client Seed:</span> {provablyFairData.clientSeed}
                                </span>
                            </div>
                          )}
                        </div>

                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>
          </main>

        </div>
      </div>
    </div>
  );
};